import { GenericKeyValueType } from '../../interfaces/generics';

export enum EntityBannerType {
  SUCCESS = 'SUCCESS',
  INFO = 'INFO',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  ALERT = 'ALERT',
  CRITICAL = 'CRITICAL'
}

export const ENTITY_BANNER_TYPE_ICON_MAP: GenericKeyValueType<EntityBannerType, string> = {
  [EntityBannerType.ERROR]: 'error-outline',
  [EntityBannerType.SUCCESS]: 'checked-tick',
  [EntityBannerType.INFO]: 'info',
  [EntityBannerType.WARNING]: 'warning',
  [EntityBannerType.ALERT]: 'warning',
  [EntityBannerType.CRITICAL]: 'error-outline'
};

export const ENTITY_BANNER_COLOR_MAP: { [key in EntityBannerType]: string } = {
  [EntityBannerType.INFO]: 'primary',
  [EntityBannerType.SUCCESS]: 'success',
  [EntityBannerType.WARNING]: 'warning',
  [EntityBannerType.ERROR]: 'error',
  [EntityBannerType.ALERT]: 'warning',
  [EntityBannerType.CRITICAL]: 'error'
};
